<template>
      <ModalSearch :term="term"  v-bind:show="showsModal" :token="token" :resulttype="resulttype"></ModalSearch>
</template>

<script>
import ModalSearch from './components/ModalSearch'

export default {
  components: { ModalSearch },
  data: () => ({ term: '', showsModal: false, resulttype: null, token: null}),
  mounted () {
    this.showsModal = false
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/SearchPlugin/SearchPluginContainer.vue